export const GRPC_ENDPOINT =
  process.env.REACT_APP_GRPC_ENDPOINT || "https://api.farmako.in";
export const AUTH_ENDPOINT =
  process.env.REACT_APP_AUTH_ENDPOINT ||
  "https://accounts.farmako.in/api/users";
